import script from "./ProvisionView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProvisionView.vue?vue&type=script&lang=ts&setup=true"

import "./ProvisionView.vue?vue&type=style&index=0&id=5a04a42c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a04a42c"]])

export default __exports__